module.exports = __webpack_public_path__ + "static/media/panton-black-italic.49b303b6.otf";